import {Component, HostListener} from '@angular/core';
import {NgClass, NgForOf, NgStyle} from '@angular/common';

@Component({
  selector: 'app-carousel',
  standalone: true,
    imports: [
        NgStyle,
        NgForOf,
        NgClass
    ],
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent  {
    slides = [
        {
            text: 'We have been working with Volmint Technologies for the past 2 years and using their software to automate our day-to-day processes. Since partnering with Volmint, we have witnessed significant improvements in operational efficiency, workflows, and enhanced communication across departments. Their intuitive system has greatly simplified our management tasks, allowing us to focus more on academic excellence.',
            name: 'MS Group of Companies',
            position: '',
            img: 'assets/image/img5.png'
        },
        {
            text: 'We were facing challenges with manual data management and a lack of integration between departments. After implementing Volmint’s UMS, we now have a fully integrated system that streamlines admissions, attendance, and grading. We are also pleased with their quick support.',
            name: 'ARNI University',
            position: '',
            img: 'assets/image/arnilogo24 (1).jpeg'
        },
        {
            text: 'We have been enrolled in Volmint’s UMS since more than a year. We are using the software to manage our administrative tasks as well as faculty and student management. The UMS helps us to manage and oversee our student and faculty data with end-to-end security. It Automates all processes from student counseling to admission and results with zero error and complete authenticity.',
            name: 'Subharti University',
            position: '',
            img: 'assets/image/subharti (1).jpg'
        },
        {
            text: 'We recently implemented Volmint Technologies\' College Management System (CMS), and it has greatly improved our daily operations. The system is intuitive and efficient, reducing our manual workload and streamlining key processes. Their team has been responsive and supportive, ensuring a smooth transition. With the CMS, we now have a centralized, well-organized system that ensures easy admission processes and access to student records.',
            name: 'Smt.  Leela Devi College',
            position: '',
            img: 'assets/image/img_7.png'
        },
    ];

    currentIndex = 0;

    setIndex(index: number) {
        this.currentIndex = index;
    }

    @HostListener('window:resize')
    onResize() {
        this.setIndex(this.currentIndex);
    }

}
